var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmptyBox = function SvgEmptyBox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 128,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#86C7EE",
    d: "M120.209 128H25.181a3.717 3.717 0 0 1-3.72-3.723V24.562h98.748V128Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C7EE",
    d: "M165.861 128h-51.396V24.562h55.116v99.679c0 2.096-1.661 3.759-3.72 3.759Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#61B6E0",
    d: "M77.337 24.563h-16.47V80.98h16.47V24.562ZM77.337 100.424h-16.47V128h16.47v-27.576Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#007ECC",
    d: "M107.855 34.067H86.112a.556.556 0 0 1-.542-.542V31.14c0-.29.253-.542.542-.542h21.743c.289 0 .542.253.542.542v2.385c0 .29-.253.542-.542.542ZM100.776 38.803H86.004a.44.44 0 0 1-.434-.434v-2.566a.44.44 0 0 1 .434-.434h14.772a.44.44 0 0 1 .434.434v2.566a.44.44 0 0 1-.434.434Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C7EE",
    d: "M93.299.781H.258l21.201 23.781h93.005L93.299.782Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#86C7EE",
    d: "M93.299.781H.258l21.201 23.781h93.005L93.299.782Z",
    opacity: 0.47
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#61B6E0",
    d: "M77.334 24.562h-16.47L43.527.782h16.47l17.337 23.78Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#007ECC",
    d: "M135.63.781h55.117l-21.166 23.781h-55.116L135.63.782Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#61B6E0",
    d: "M165.861 128h-51.396V24.562h55.116v99.679c0 2.096-1.661 3.759-3.72 3.759Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyBox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EmptyBox.15a51d3f.svg";
export { ForwardRef as ReactComponent };